import React from 'react';

import CardDesign from '../CommonComponents/CardDesign';

export default function SubscriptionSection({ handleLinkClick, subscriptionData, websiteLandingPageInfo }) {
  return (
    <CardDesign
      title={websiteLandingPageInfo?.is_subscription_title_present && websiteLandingPageInfo?.subscription_title}
      subTitle={websiteLandingPageInfo?.is_subscription_subtitle_present && websiteLandingPageInfo?.subscription_subtitle}
      cardType="subscription"
      data={subscriptionData}
      handleLinkClick={handleLinkClick}
      showArrow={false}
    />
  )
}
